export const SET_MEETING_TOKEN = 'auth/SET_MEETING_TOKEN';

export const ADMIN_LOGIN = 'auth/ADMIN_LOGIN';
export const ADMIN_LOGIN_PENDING = 'auth/ADMIN_LOGIN_PENDING';
export const ADMIN_LOGIN_FULFILLED = 'auth/ADMIN_LOGIN_FULFILLED';
export const ADMIN_LOGIN_REJECTED = 'auth/ADMIN_LOGIN_REJECTED';
